import React from 'react';
import { cn } from "../utils/style";

function Loading({message, className, fullHeight = true}) {
	return (
		<div className={cn(
			"flex flex-col items-center justify-center gap-4 select-none animate-fade-in",
			fullHeight ? "h-64" : "h-auto py-8",
			className
		)}>
			<div className="relative flex items-center justify-center">
				<div className="h-12 w-12 rounded-full border-4 border-gray-100"></div>
				<div className="absolute h-12 w-12 rounded-full border-4 border-t-[#0b9cbc] border-r-transparent border-b-transparent border-l-transparent animate-spin"></div>
				
				<div className="absolute h-6 w-6 rounded-full bg-gradient-to-br from-[#0b5f82] to-[#0b9cbc] opacity-20 animate-pulse"></div>
			</div>
			
			<div className="flex flex-col items-center gap-1">
				<span className="text-[10px] font-black uppercase tracking-[0.2em] text-[#0b5f82] opacity-80">
					{message || 'Loading'}
				</span>
				<div className="flex gap-1">
					<div className="h-1 w-1 rounded-full bg-[#0b9cbc] animate-bounce [animation-delay:-0.3s]"></div>
					<div className="h-1 w-1 rounded-full bg-[#0b9cbc] animate-bounce [animation-delay:-0.15s]"></div>
					<div className="h-1 w-1 rounded-full bg-[#0b9cbc] animate-bounce"></div>
				</div>
			</div>
		</div>
	);
}

export default Loading;